import {
  ALL_LAYOUT_ARGS,
  CONTAINER_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
} from '../../../utils/spds/metadata';
import FlexColumn from './flex/column.gjs';
import FlexReverseColumn from './flex/reverse-column.gjs';
import FlexReverseRow from './flex/reverse-row.gjs';
import FlexRow from './flex/row.gjs';
import GridContainer from './grid/container.gjs';
import Super from '../core/base.gjs';

const METADATA = {
  meta: {
    ...ALL_LAYOUT_ARGS.meta,
    ...pickArgs(CONTAINER_ARGS, ['grid', 'reverse']).meta,
    column: {
      ...pickArgs(CONTAINER_ARGS, ['column']).meta.column,
      defaultValue: true,
    },
  },
};

export default class SpdsLayoutVariable extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-layout-variable';

  constructor() {
    super(...arguments);

    this.arguments = this.composeArguments(METADATA);
  }

  get column() {
    return this.args.column ?? getDefaultValueFromMetadata(METADATA, 'column');
  }

  get component() {
    if (this.grid) return GridContainer;

    if (this.reverse) {
      return this.column ? FlexReverseColumn : FlexReverseRow;
    }

    return this.column ? FlexColumn : FlexRow;
  }

  get grid() {
    return this.args.grid ?? getDefaultValueFromMetadata(METADATA, 'grid');
  }

  get reverse() {
    return this.args.reverse ?? getDefaultValueFromMetadata(METADATA, 'reverse');
  }

  <template>
    <this.component
      @alignContent={{@alignContent}}
      @alignItems={{@alignItems}}
      @alignSelf={{@alignSelf}}
      @area={{@area}}
      @areas={{@areas}}
      @autoFlow={{@autoFlow}}
      @columns={{@columns}}
      @flex={{@flex}}
      @flexWrap={{@flexWrap}}
      @gap={{@gap}}
      @gridArea={{@gridArea}}
      @gridAutoColumns={{@gridAutoColumns}}
      @gridAutoFlow={{@gridAutoFlow}}
      @gridAutoRows={{@gridAutoRows}}
      @gridColumn={{@gridColumn}}
      @gridRow={{@gridRow}}
      @gridTemplateAreas={{@gridTemplateAreas}}
      @gridTemplateColumns={{@gridTemplateColumns}}
      @gridTemplateRows={{@gridTemplateRows}}
      @id={{@id}}
      @justifyContent={{@justifyContent}}
      @justifyItems={{@justifyItems}}
      @justifySelf={{@justifySelf}}
      @order={{@order}}
      @row={{@row}}
      @rows={{@rows}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      class={{this.classes}}
      data-test-spds-layout-variable
      ...attributes
    >
      {{yield}}
    </this.component>
  </template>
}

export const VARIABLE_LAYOUT_METADATA = SpdsLayoutVariable.metadata;
